import { render, staticRenderFns } from "./job-setup-layout.component.vue?vue&type=template&id=7c3c2b52"
import script from "./job-setup-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./job-setup-layout.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c3c2b52')) {
      api.createRecord('7c3c2b52', component.options)
    } else {
      api.reload('7c3c2b52', component.options)
    }
    module.hot.accept("./job-setup-layout.component.vue?vue&type=template&id=7c3c2b52", function () {
      api.rerender('7c3c2b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/layout/job-setup-layout.component.vue"
export default component.exports